import { manageErrorLogs } from "./commonFunction";
import { clearTables, checkTablesInDB, safeTransaction } from "./db";

export const insertTakedDetailsInDB = async (data) => {
  try {
    const tables = ["takedDetails", "addedTakeDetails"];
    checkTablesInDB(tables);
    await safeTransaction(tables, async (tx) => {
      const restaurantDetailsTable = tx.table(tables[0]);
      await clearTables(tx, tables);
      if (Array.isArray(data) && data?.length > 0) {
        await restaurantDetailsTable.bulkPut(data);
      }
    });
  } catch (error) {
    manageErrorLogs(error);
    return null;
  }
};
